import React from "react";
import { Loading } from "../../components";
import { ApiHelper, DateHelper, VerboseLogInterface } from "../../helpers";

interface Props {
  deviceId: number
}

export const VerboseLogs: React.FC<Props> = props => {

  const [logs, setLogs] = React.useState<VerboseLogInterface[]>(null);

  const init = () => { ApiHelper.get("/verboseLogs/device/" + props.deviceId).then((data) => setLogs(data)); }

  const getLogEntries = () => {
    const result: JSX.Element[] = [];
    logs?.forEach(l => {
      const displayTime = DateHelper.prettyDateTime(DateHelper.convertToDate(l.logTime));
      const data = JSON.parse(l.data);
      const dataProps: JSX.Element[] = [];
      for (const prop in data) dataProps.push(<div>{data[prop]}</div>)

      result.push(<tr>
        <td>{displayTime}</td>
        <td>{l.name}</td>
        <td>{dataProps}</td>
      </tr>);
    });
    return result;
  }

  React.useEffect(init, [props.deviceId])

  if (logs === null) return <Loading />
  else if (logs.length === 0) return <></>
  else return (
    <>
      <h3>Verbose Logs</h3>
      <table className="table table-sm" style={{ fontSize: 11 }}>
        <tbody><tr><th>Time</th><th>Action</th><th>Details</th></tr>
          {getLogEntries()}
        </tbody>
      </table>
    </>
  );
};